import { Component } from "react";

import Link from "admin/shared/ui/Link.Component";

import Button from "@material-ui/core/Button";

export default class SavelendActions extends Component {
  render() {
    let id = this.props.userId;

    return (
      <div className=" user-panel-navigation">
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userOverview"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Overview
          </Button>
        </Link>
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userTransactions"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Transactions
          </Button>
        </Link>
        <Link
          className="user-panel-navigation-item"
          activeClassName={"selected"}
          toState={"userOrders"}
          onlyActiveOnIndex={true}
          parameters={["query", id]}
        >
          <Button variant="contained" color="primary">
            Orders
          </Button>
        </Link>
      </div>
    );
  }
}
